export default function IconArrowDown({className}) {
	return (
		<svg className={className} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M20 10L10 20L-4.37114e-07 10L1.208 8.792L9.14582 16.7298L9.14582 -4.74451e-07L10.8542 -3.99776e-07L10.8542 16.7298L18.792 8.792L20 10Z" fill="currentColor"/></svg>
	)
}